var map = {
	"./buys.jpg": "4bfe",
	"./buys_color.jpg": "f2f7",
	"./defaultprofilepic.jpg": "01a4",
	"./exercise.jpg": "872a",
	"./female.jpg": "b952",
	"./footer_bg.jpg": "f8c9",
	"./history1.jpg": "909b",
	"./history10.jpg": "27d1",
	"./history11.jpg": "9463",
	"./history12.jpg": "013f",
	"./history13.jpg": "c560",
	"./history2.jpg": "b13d",
	"./history3.jpg": "352e",
	"./history4.jpg": "e722",
	"./history5.jpg": "5944",
	"./history6.jpg": "9b21",
	"./history7.jpg": "c0cb",
	"./history8.jpg": "a8ad",
	"./history9.jpg": "7ed8",
	"./login_content.jpg": "929c",
	"./loginpage_bg.jpg": "ee3b",
	"./male.jpg": "9cb8",
	"./payment_main.jpg": "6aef",
	"./quiz-skate-1.jpg": "43c9",
	"./quiz-skate-2.jpg": "9672",
	"./quiz-skate-4.jpg": "06b5",
	"./skate-quiz-bg.jpg": "3a4d",
	"./skate_footer.jpg": "8b9d",
	"./user_manual.jpg": "81f1",
	"./user_photo.jpg": "c1c2",
	"./v-q-1.jpg": "2ae7",
	"./v-q-2.jpg": "a353",
	"./video1.jpg": "ad15",
	"./video2.jpg": "ff2a",
	"./video3.jpg": "7d6b",
	"./video4.jpg": "a799",
	"./video5.jpg": "df0c",
	"./video6.jpg": "cc92",
	"./workout1.jpg": "fc92",
	"./workout10.jpg": "e9fd",
	"./workout2.jpg": "8b7c",
	"./workout3.jpg": "e9b9",
	"./workout4.jpg": "4a5a",
	"./workout5.jpg": "4305",
	"./workout6.jpg": "3f0a",
	"./workout7.jpg": "e1e6",
	"./workout8.jpg": "1ea1",
	"./workout9.jpg": "589e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d1e";